import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import moment from "moment";

import LocationSearch from "../Locationsearch";
import CheckInCheckOutCalender from "../global/checkin-checkout-calander";
import GuestInput from "../guest-input/Guestinput";
import Button from "../global/button";
import { initialSearchState } from "../../pages/property-listing";
import { generateListingUrl, processListingParams } from "../../utils/formatting";
import { ReactComponent as Hippologo } from "../../assets/hippologo.svg";

import "./style.css";

function NotFound() {
  const [searchCriteria, setSearchCriteria] = useState(initialSearchState);
  const [errors, setErrors] = useState({
    location: null,
    guests: null,
    bookingDates: null,
  });
  const [isTouched, setIsTouched] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const params = processListingParams(location.search);

  params.location.country = null;

  const goToPropertyListingPage = (limit, page, searchRoomCountType, filters = null, sortType = null) => {
    setIsTouched(true);

    if (!searchRoomCountType) {
      searchRoomCountType = "suggestion";
    }

    const newErrors = { ...errors };

    const { location, guests, bookingDates } = searchCriteria;

    const noLocation = _.isEmpty(location?.country);

    if (noLocation) {
      newErrors.location = "Please select a location";
    }

    if (guests.childCount > 0) {
      if (guests.childAges.length === 0) {
        newErrors.guests = "Please select the child age";
      }

      const isValidAge = guests.childAges.every((age) => age >= 0 && age < 18);

      if (!isValidAge) {
        newErrors.guests = "Please select the child age";
      }
    }

    let noOfNights = moment(bookingDates.checkoutDate).diff(moment(bookingDates.checkinDate), "days");

    if (noOfNights > 90) {
      newErrors.bookingDates = "Select a date range up to 90 days";
    }

    let checkin = moment(bookingDates.checkinDate);
    let checkout = moment(bookingDates.checkoutDate);

    // if (!checkin.isValid()) {
    //   newErrors.bookingDates = "Please select dates";
    // }

    if (Object.values(newErrors).some((error) => error)) {
      setErrors(newErrors);
      return;
    }

    if (!checkout.isValid() || checkout.isBefore(checkin) || checkin.isSame(checkout, "day")) {
      checkout = checkin.clone().add(1, "day");

      setSearchCriteria((prev) => ({
        ...prev,
        bookingDates: {
          checkinDate: checkin.format("YYYY-MM-DD"),
          checkoutDate: checkout.format("YYYY-MM-DD"),
        },
      }));
    }

    limit = limit || params.pagination.limit;
    page = page || params.pagination.page;

    // This is important - Use the latest booking dates within the same render cycle.
    const finalBookingDates = {
      checkinDate: checkin.format("YYYY-MM-DD"),
      checkoutDate: checkout.format("YYYY-MM-DD"),
    };

    const url = generateListingUrl({
      params,
      searchCriteria: {
        ...searchCriteria,
        bookingDates: finalBookingDates,
      },
      searchOptions: {
        roomCountType: searchRoomCountType,
      },
      pagination: {
        limit,
        page,
      },
      filters: filters ?? {},
      sortType: sortType,
    });

    navigate(url);
  };

  return (
    <div className="not-found ">
      <Hippologo className="hippo-logo" />
      <div className="not-found-content container">
        <div className="not-found-text">
          <h1 className="not-found-status">404</h1>
          <h2 className="not-found-title">Page Not Found</h2>
          <p className="not-found-message">We can't find the page you're looking for. Use the search bar below to navigate back on track</p>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            goToPropertyListingPage();
          }}
        >
          <div className="prop-listing-search">
            <div>
              <LocationSearch searchCriteria={searchCriteria} setSearchCriteria={setSearchCriteria} setErrors={setErrors} />
              {isTouched && errors.location && <div className="error-msg-home">{errors.location || "Please select a location"}</div>}
            </div>

            <div className="top-filter">
              <CheckInCheckOutCalender searchCriteria={searchCriteria} setSearchCriteria={setSearchCriteria} setErrors={setErrors} />
              {/* {isTouched && errors.bookingDates && <div className="error-msg">{errors.bookingDates || "Please select dates"}</div>} */}
            </div>

            <div className="top-filter">
              <GuestInput searchCriteria={searchCriteria} setSearchCriteria={setSearchCriteria} setErrors={setErrors} />
              {isTouched && errors.guests && <div className="error-msg">{errors.guests || "Please select the child age"}</div>}
            </div>
            <Button className="listing-search-btn" type="submit">
              Apply Changes
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default NotFound;
